import Vue from 'vue'
import VueHead from 'vue-head'
import VueRouter from 'vue-router'
import ls from 'local-storage'

import About from '../pages/About.vue'

import AdEditor from '../pages/app/ads/AdEditor.vue'
import AdsIndex from '../pages/app/ads/AdsIndex.vue'
import AppraisalContainer from '../pages/app/appraisals/AppraisalContainer.vue'
import AppraisalEditor from '../pages/app/appraisals/AppraisalEditor.vue'
import AppraisalFileEditor from '../pages/app/files/AppraisalFileEditor.vue'
import AppraisalFilesIndex from '../pages/app/files/AppraisalFilesIndex.vue'
import AppraisalInvoicesIndex from '../pages/app/appraisalinvoices/AppraisalInvoicesIndex.vue'
import AppraisalReportEditor from '../pages/app/appraisalreports/AppraisalReportEditor.vue'
import AppraisalQuoteEditor from '../pages/app/appraisalquotes/AppraisalQuoteEditor.vue'
import AppraisalInvoiceEditor from '../pages/app/appraisalinvoices/AppraisalInvoiceEditor.vue'
import AppraisalsIndex from '../pages/app/appraisals/AppraisalsIndex.vue'
import AppraiserEditor from '../pages/app/appraisers/AppraiserEditor.vue'
import AppraisersIndex from '../pages/app/appraisers/AppraisersIndex.vue'
import BecPropertiesIndex from '../pages/app/becproperties/BecPropertiesIndex.vue'
import BecPriceEditor from '../pages/app/becprices/BecPriceEditor.vue'
import BecPropertyEditor from '../pages/app/becproperties/BecPropertyEditor.vue'
import BdefilesIndex from '../pages/app/bdefiles/BdefilesIndex.vue'
import BdefilesEditor from '../pages/app/bdefiles/BdefilesEditor.vue'
import ConstraintEditor from '../pages/app/constraints/ConstraintEditor.vue'
import Contact from '../pages/Contact.vue'
import ContactEditor from '../pages/app/contacts/ContactEditor.vue'
import ContactsIndex from '../pages/app/contacts/ContactsIndex.vue'
import CustomerService from '../pages/CustomerService.vue'
import EmailAddressEditor from '../pages/app/emailaddresses/EmailAddressEditor.vue'
import EntityEditor from '../pages/app/entities/EntityEditor.vue'
import EntitiesIndex from '../pages/app/entities/EntitiesIndex.vue'
import Home from '../pages/Home.vue'
import Main from '../pages/Main.vue'
import MarketStudyEditor from '../pages/app/marketstudies/MarketStudyEditor.vue'
import NoteEditor from '../pages/app/notes/NoteEditor.vue'
import NotFound from '../pages/NotFound.vue'
import RealEstatesIndex from '../pages/app/realestates/RealEstatesIndex.vue'
import RealEstateEditor from '../pages/app/realestates/RealEstateEditor.vue'
import Restricted from '../pages/Restricted.vue'
import LogIn from '../pages/auth/LogIn.vue'
import NV from '../pages/app/NV.vue'
import Dashboard from '../pages/app/Dashboard.vue'
import OurClients from '../pages/OurClients.vue'
import Philosophy from '../pages/Philosophy.vue'
import PhotographEditor from '../pages/app/photographs/PhotographEditor.vue'
import RegistryAnnexEditor from '../pages/app/registryannexes/RegistryAnnexEditor.vue'
import UrbanAnnexEditor from '../pages/app/urbanannexes/UrbanAnnexEditor.vue'
import CadasterAnnexEditor from '../pages/app/cadasterannexes/CadasterAnnexEditor.vue'
import PlanAnnexEditor from '../pages/app/planannexes/PlanAnnexEditor.vue'
import ProjectEditor from '../pages/app/projects/ProjectEditor.vue'
import CessionAnnexEditor from '../pages/app/cessionannexes/CessionAnnexEditor.vue'
import OtherAnnexEditor from '../pages/app/otherannexes/OtherAnnexEditor.vue'
import Public from '../pages/app/Public.vue'
import Pricing from '../pages/Pricing.vue'
import QuoteRequest from '../pages/QuoteRequest.vue'
import Services from '../pages/Services.vue'
import SignUp from '../pages/auth/SignUp.vue'
import SupervisorEditor from '../pages/app/supervisors/SupervisorEditor.vue'
import SupervisorsIndex from '../pages/app/supervisors/SupervisorsIndex.vue'
import TelephoneNumberEditor from '../pages/app/telephonenumbers/TelephoneNumberEditor.vue'
import WarningEditor from '../pages/app/warnings/WarningEditor.vue'

// TODO: repassar que tota el CREATE I DELETE funcioni correctament en tots els objectes (si al borrar es borren també els seus parents i paths dependents que també haurien de borrar-se, etc)

import _ from 'lodash'

import store from '../store/index.js'

Vue.use(VueHead)
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/', name: 'home', component: Home},
        {path: '/sobre-nosotros', name: 'about', component: About},
        {path: '/dashboard', name: 'dashboard', component: Dashboard, meta: {requiresAuth: true}},
        {
            path: '/ad-editor',
            name: 'ad-editor',
            component: AdEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/ads-index',
            name: 'ads-index',
            component: AdsIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/realestate-editor',
            name: 'realestate-editor',
            component: RealEstateEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisal-container',
            name: 'appraisal-container',
            component: AppraisalContainer,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisal-editor',
            name: 'appraisal-editor',
            component: AppraisalEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisalfile-editor',
            name: 'appraisalfile-editor',
            component: AppraisalFileEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisalreport-editor',
            name: 'appraisalreport-editor',
            component: AppraisalReportEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisalquote-editor',
            name: 'appraisalquote-editor',
            component: AppraisalQuoteEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisalinvoice-editor',
            name: 'appraisalinvoice-editor',
            component: AppraisalInvoiceEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisals-index',
            name: 'appraisals-index',
            component: AppraisalsIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraiser-editor',
            name: 'appraiser-editor',
            component: AppraiserEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisers-index',
            name: 'appraisers-index',
            component: AppraisersIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/supervisor-editor',
            name: 'supervisor-editor',
            component: SupervisorEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/supervisors-index',
            name: 'supervisors-index',
            component: SupervisorsIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/bdefiles-index',
            name: 'bdefiles-index',
            component: BdefilesIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/bdefiles-editor',
            name: 'bdefiles-editor',
            component: BdefilesEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/becproperties-index',
            name: 'becproperties-index',
            component: BecPropertiesIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/becproperty-editor',
            name: 'becproperty-editor',
            component: BecPropertyEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/becprice-editor',
            name: 'becprice-editor',
            component: BecPriceEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/emailaddress-editor',
            name: 'emailaddress-editor',
            component: EmailAddressEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/entity-editor',
            name: 'entity-editor',
            component: EntityEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/entities-index',
            name: 'entities-index',
            component: EntitiesIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/marketstudy-editor',
            name: 'marketstudy-editor',
            component: MarketStudyEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/realestates-index',
            name: 'realestates-index',
            component: RealEstatesIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/telephonenumber-editor',
            name: 'telephonenumber-editor',
            component: TelephoneNumberEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisalfiles-index',
            name: 'appraisalfiles-index',
            component: AppraisalFilesIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/appraisalinvoices-index',
            name: 'appraisalinvoices-index',
            component: AppraisalInvoicesIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {path: '/contacto', name: 'contact', component: Contact},
        {
            path: '/contact-editor',
            name: 'contact-editor',
            component: ContactEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/contacts-index',
            name: 'contacts-index',
            component: ContactsIndex,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/constraint-editor',
            name: 'constraint-editor',
            component: ConstraintEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/photograph-editor',
            name: 'photograph-editor',
            component: PhotographEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/urban-annex-editor',
            name: 'urban-annex-editor',
            component: UrbanAnnexEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/registry-annex-editor',
            name: 'registry-annex-editor',
            component: RegistryAnnexEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/cadaster-annex-editor',
            name: 'cadaster-annex-editor',
            component: CadasterAnnexEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/plan-annex-editor',
            name: 'plan-annex-editor',
            component: PlanAnnexEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/cession-annex-editor',
            name: 'cession-annex-editor',
            component: CessionAnnexEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/other-annex-editor',
            name: 'other-annex-editor',
            component: OtherAnnexEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/project-editor',
            name: 'project-editor',
            component: ProjectEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/note-editor',
            name: 'note-editor',
            component: NoteEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {
            path: '/warning-editor',
            name: 'warning-editor',
            component: WarningEditor,
            meta: {requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor']}
        },
        {path: '/servicio-atencion-cliente', name: 'customer-service', component: CustomerService},
        {path: '/iniciar-sesion', name: 'login', component: LogIn},
        {path: '/nuestros-clientes', name: 'our-clients', component: OurClients},
        {path: '/filosofia', name: 'philosophy', component: Philosophy},
        {path: '/tarifas', name: 'pricing', component: Pricing},
        {path: '/presupuesto', name: 'quote-request', component: QuoteRequest},
        {path: '/restricted', name: 'restricted', component: Restricted},
        {path: '/servicios', name: 'services', component: Services},
        {path: '/main', name: 'main', component: Main},
        {path: '/signup', name: 'signup', component: SignUp},
        {path: '/n/:id', name: 'public', component: Public},
        {path: '/error', name: 'error', component: Error},
        {path: '*', name: 'notfound', component: NotFound}
    ]
})

router.beforeEach((to, from, next) => {

    const user = ls.get('user')
    const user_role = store.getters.user_role

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (user) {

            if (to.meta.allowedRoles) {

                //console.log(user_role)
                let f = _.includes(to.meta.allowedRoles, user_role)

                //console.log(f)
                if (f) {
                    next()
                } else {
                    console.log("restricted...")
                    next({name: 'restricted', query: {redirect: to.fullPath}})
                }

            } else {
                next()
            }


        } else {
            next({name: 'login', query: {redirect: to.fullPath}})
        }

    } else {

        // next()

        if (user && to.name !== 'public') {
            next({name: 'dashboard'})
        } else {
            next()
        }

    }

    window.scrollTo(0, 0)
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js